module.exports = __webpack_public_path__ + "img/ic_launcher_round.de1acaf4.png";